import React from 'react';
import { processSilentRenew } from 'redux-oidc';

const RenewPage = () => {
    processSilentRenew();
    return <div>renewing token...</div>;
};

export default RenewPage;